const infoBlock = document.querySelectorAll('.js--info_block');

if (infoBlock) {
  infoBlock.forEach((item) => {
    item.style.setProperty('--set-color', item.getAttribute('data-color'));
  });
}
